module.exports = __webpack_public_path__ + "img/2019-1.edc8b0f6.jpg";